import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";
import "../../../css/OfferMediaUploader.css";

export default function SampleImageCropper({
	image,
	file,
	onCropDone,
	onClose,
}) {
	const [crop, setCrop] = useState({ x: 0, y: 0 });

	const [zoom, setZoom] = useState(1);

	const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

	const [loading, setLoading] = useState(false);

	const onCropComplete = useCallback((_, croppedPixels) => {
		setCroppedAreaPixels(croppedPixels);
	}, []);

	const handleDone = async () => {
		try {
			setLoading(true);

			const croppedFile = await getCroppedImg(
				image,
				croppedAreaPixels,
				file.name,
			);

			onCropDone(croppedFile);

			setLoading(false);
		} catch (e) {
			console.log(e);
			alert("Unable to crop image");
			setLoading(false);
		}
	};

	return (
		<div className="cropper-overlay">
			<div className="cropper-container">
				<div className="cropper-box">
					<Cropper
						image={image}
						crop={crop}
						zoom={zoom}
						aspect={9 / 16}
						onCropChange={setCrop}
						onCropComplete={onCropComplete}
						onZoomChange={setZoom}
					/>
				</div>

				<div className="zoom-container">
					<span>Zoom</span>

					<input
						type="range"
						min={1}
						max={3}
						step={0.1}
						value={zoom}
						onChange={(e) => setZoom(Number(e.target.value))}
					/>
				</div>

				<div className="crop-actions">
					<button
						type="button"
						className="btn btn-secondary"
						onClick={onClose}
					>
						Cancel
					</button>

					<button
						type="button"
						className="btn btn-primary"
						onClick={handleDone}
						disabled={loading}
					>
						{loading ? "Cropping..." : "Crop & Save"}
					</button>
				</div>
			</div>
		</div>
	);
}
